import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  marginBottom: {
    marginBottom: theme.spacing(2),
  },
  richTextMarginBottom: {
    marginBottom: theme.spacing(2),
  },
}));
